import { Box, Divider, Tab, Tabs } from "@mui/material"
import { FC, useMemo } from "react"
import { Helmet } from 'react-helmet-async'
import { Redirect, useLocation } from 'react-router-dom'
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource";
import { Content } from "@/components/content/Content"
import { Link, matchPath } from 'react-router-dom'
import { allowOrgSettingRoute } from "@/authProvider/permissionMap";
import { useHasFeature } from "@/utils/useHasFeature";
import { useOdPermissions } from "@/authProvider/useOdPermissions";


const Settings: FC<WrappedComponentProps> = ({ 
  children, 
  tabs,
  options,
}) => {
  const permissions = useOdPermissions()
  const location = useLocation()
  const { rest: activeItem } = 
    matchPath<{rest:string}>(location.pathname, { path: '/settings/organization/:rest'})?.params || {}
  const hasFeature = useHasFeature()

  const allowedTabs = useMemo(() => tabs.filter(tab => allowOrgSettingRoute(tab.primaryPath || tab.path, permissions, hasFeature)), [tabs, permissions])
  if (permissions && location.pathname.length > '/settings/organization/'.length) {
    if (!allowOrgSettingRoute(location.pathname, permissions, hasFeature)) {
      return <Redirect to="/" />
    }
  }
  
  if (location.pathname === '/settings/organization/profile/create') {
    return (<>{children}</>)
  }

  return (
    <Content pageName="Organization Settings" resourceName="Organization Settings" breadcrumbs={options?.breadcrumbs} >
      <Helmet>
        <title>Organization Settings | OnData</title>
      </Helmet>
      <Tabs
        indicatorColor="primary"
        scrollButtons="auto"
        textColor="primary"
        variant="scrollable"
        value={`/settings/organization/${activeItem}`}
      >
        {allowedTabs.map((tab) => (
          <Tab
            component={Link}
            key={tab.path}
            label={tab.label}
            value={tab.path}
            to={tab.primaryPath || tab.path}
          />
        ))}
      </Tabs>
      <Divider />
      <Box sx={{ mt: 3 }}>
        {children}
      </Box>
    </Content>
  )
}

export const OrganizationSettingsComposite = withCompositeResource(Settings);
